/**
 * @generated SignedSource<<e27c68d460f2ea0e9269a5c9dcefe534>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BillingSettingsInput = {
  billingEmailAddress: string;
  clientMutationId: string;
  enabled: boolean;
  invoiceTemplate?: string | null;
  ownerUid: string;
  platform: string;
};
export type BillingSettingsDialogMutation$variables = {
  input: BillingSettingsInput;
};
export type BillingSettingsDialogMutation$data = {
  readonly saveBillingSettings: {
    readonly settings: {
      readonly billingCreditsLimit: number;
      readonly billingEmailAddress: string;
      readonly enabled: boolean;
      readonly invoiceTemplate: string | null;
      readonly ownerUid: string;
      readonly platform: string;
    };
  };
};
export type BillingSettingsDialogMutation = {
  response: BillingSettingsDialogMutation$data;
  variables: BillingSettingsDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BillingSettingsPayload",
    "kind": "LinkedField",
    "name": "saveBillingSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "platform",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ownerUid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billingCreditsLimit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billingEmailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceTemplate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BillingSettingsDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BillingSettingsDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8fb5fb4cca34c46f6d29e7ffe876a280",
    "id": null,
    "metadata": {},
    "name": "BillingSettingsDialogMutation",
    "operationKind": "mutation",
    "text": "mutation BillingSettingsDialogMutation(\n  $input: BillingSettingsInput!\n) {\n  saveBillingSettings(input: $input) {\n    settings {\n      platform\n      ownerUid\n      enabled\n      billingCreditsLimit\n      billingEmailAddress\n      invoiceTemplate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c836edc326a6312158e7543252ebd000";

export default node;
